module.exports = __webpack_public_path__ + "img/image2-mobile.2047c8f6.png";